import { render, staticRenderFns } from "./CreateGroupSidebar.vue?vue&type=template&id=4f4d80f5&scoped=true"
import script from "./CreateGroupSidebar.vue?vue&type=script&lang=js"
export * from "./CreateGroupSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupSidebar.vue?vue&type=style&index=0&id=4f4d80f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d80f5",
  null
  
)

export default component.exports